import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/usereduxHooks";
import { getItem } from "../utils/localStorage";

export default function PrivateRoute({ children }: { children: any }) {
  const { user } = useAppSelector((store) => store.User);

  // Check both Redux state and localStorage for token
  // This allows direct URL access when user is already logged in
  const token = user?.jwtToken;
  const tokenData = getItem("token");
  const localStorageToken = tokenData?.token;

  // If user has token in either Redux or localStorage, allow access
  if (token || localStorageToken) {
    return children;
  }

  return <Navigate to="/signin" replace />;
}
